<template>
  <div>
    <div style="margin: 0 20px;max-height: 360px;overflow-y: auto">
      <el-table size="mini" border :data="tableData" style="width: 100%">
        <el-table-column
          prop="type_name"
          label="文件类型"
          min-width="60">
        </el-table-column>
        <el-table-column
          prop="att_name"
          label="文件名"
          width="180" align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="文件内容"
          min-width="120" align="center">
          <template slot-scope="scope">
            <img style="height: 100px" v-if="scope.row.uri !== '' && scope.row.fileType !== 'pdf'" :src="scope.row.uri"/>
            <span v-if="scope.row.fileType === 'pdf'">查看详情PDF</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="esp_name"
          label="操作人"
          min-width="70" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.id === 0" size="mini" @click="addBtn(scope.row)" type="primary" plain>上传</el-button>
            <el-button v-if="scope.row.id !== 0" size="mini" @click="seeBtn(scope.row)" type="warning" plain>查看</el-button>
            <el-button v-if="scope.row.id !== 0" size="mini" @click="editBtn(scope.row)" type="success" plain>编辑</el-button>
            <el-button v-if="scope.row.id !== 0" size="mini" @click="delBtn(scope.row)" type="danger" plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 20px"></div>
    <el-dialog width="500px" :title="addEditTitle" :visible.sync="addEditFile" v-if="addEditFile" append-to-body>
      <div style="text-align: center" v-if="sendForm.id === 0">
        <el-upload class="upload-demo" :limit=limitNum :auto-upload="false" accept="."
                   action="#" :on-change="fileChange" :on-exceed="exceedFile"
                   :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemoveFile"
                   :file-list="fileList" list-type="text" ref="file">
          <el-button size="mini" icon="el-icon-upload2" type="primary" plain>上传文件</el-button>
          <div slot="tip" class="el-upload__tip" style="color: #999999">只能上传.pdf \ .png \ .jpg文件</div>
        </el-upload>
      </div>
      <el-form style="margin-top: 20px;margin-right: 30px" :model="sendForm" :rules="fileRules" ref="sendForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="文件名" prop="att_name">
          <el-input v-model="sendForm.att_name" placeholder="请输入文件名"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 30px;height: 50px">
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="addEditFile = false">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEditFile('sendForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog width="900px" :title="addEditTitle" :visible.sync="openFile" v-if="openFile" append-to-body>
      <div style="text-align: center">
        <iframe v-if="sendForm.fileType === 'pdf'" :src="sendForm.uri" height="500px;" width="800px"></iframe>
        <img style="max-width: 100%" v-if="sendForm.uri !== ''" :src="sendForm.uri"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {uploadfile, queryservicefilelist, queryservicefileupdate} from '../../../api/yanglaoyuan'
import {getToken} from '../../../utils/auth'
export default {
  name: 'servicePersonFile',
  props: {
    infoRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      token: '',
      servicepersonRow: '',
      tableData: [],
      row: '',
      sendForm: {
        'oper_type': 0,
        'id': 0,
        'eid': 0,
        'typeid': 0,
        'oid': 0,
        'oid2': 0,
        'fileid': 0,
        'att_name': '',
        'esp_id': 0,
        'esp_name': ''
      },
      addEditTitle: '',
      addEditFile: false,
      fileForm: {
        sfzPhoto: [],
        fileArr: []
      },
      fileRules: {
        att_name: [{required: true, message: '请输入文件名', trigger: 'blur'}]
      },
      // 身份证
      dialogImageUrl: '',
      dialogImageUrlArray: [],
      hideUpload: false,
      dialogVisible: false,
      // 上传合同
      limitNum: 1, // 上传同时允许上传的最大数
      fileList: [],
      openFile: false,
      fileurl: ''
    }
  },
  created () {
    this.token = getToken()
    this.servicepersonRow = this.infoRow.formServicePerson
    this.getStart()
    console.log(window.location.protocol + '//' + window.location.host, window.location.host.indexOf('localhost'))
  },
  methods: {
    getStart () {
      console.log(this.infoRow)
      if (this.servicepersonRow === '' || this.servicepersonRow.id === 0) {
        this.$message({
          message: '请先添加员工基本信息。',
          type: 'warning'
        })
        return
      }
      this.getFileTable()
    },
    getFileTable () {
      let data = {
        eid: this.servicepersonRow.e_id,
        id1: this.servicepersonRow.id
      }
      this.tableData = []
      queryservicefilelist(data).then(res => {
        for (let i = 0; i < res.data.arrdata.length; i++) {
          let obj = res.data.arrdata[i]
          if (obj.type_name !== '其他') {
            obj.fileType = obj.uri !== '' ? obj.uri.split('.')[obj.uri.split('.').length - 1] : ''
            this.tableData.push(obj)
          }
        }
      })
    },
    // 上传文件
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    // 文件状态改变时的钩子
    async fileChange (file, fileList) {
      let vm = this
      // this.fileList = []
      let types = ['pdf', 'jpg', 'png']
      if (types.indexOf(file.name.split('.')[file.name.split('.').length - 1]) === -1) {
        vm.$message({type: 'error', message: '不支持该文件类型！'})
        this.$refs['file'].clearFiles()
        return
      }
      let obj = {
        raw: file.raw,
        filename: this.row.type_name,
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传文件', type: 'success' })
        this.sendForm.fileid = res.data.fileid
        this.sendForm.att_name = file.name
        // console.log('send', this.fileList, file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.file.uploadFiles = []
        this.$message({ message: '上传文件失败', type: 'error' })
      })
    },
    // 文件超出个数限制时的钩子
    exceedFile (files, fileList) {
      // this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`)
      this.$message.warning(`只能选择 ${this.limitNum} 个文件。`)
    },
    handleRemoveFile (file, fileList) {
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].id === file.id) {
          this.fileList.remove(this.fileList[i])
        }
      }
      console.log(99, this.fileList, this.fileForm.fileArr)
    },
    // 上传附件
    addBtn (row) {
      this.row = row
      this.sendForm = {
        'oper_type': 0,
        'id': 0,
        'eid': this.servicepersonRow.e_id,
        'typeid': row.type_id,
        'oid': this.servicepersonRow.id,
        'oid2': 0, // 入住id
        'fileid': 0,
        'att_name': '',
        'esp_id': this.$store.state.user.syspersonid,
        'esp_name': this.$store.state.user.personname
      }
      this.addEditTitle = '上传文件'
      this.addEditFile = true
    },
    // 查看
    seeBtn (row) {
      this.row = row
      this.sendForm = row
      this.addEditTitle = '【' + row.att_name + '】文件详情'
      this.openFile = true
      console.log(this.sendForm)
    },
    // 编辑附件
    editBtn (row) {
      this.row = row
      this.sendForm = {
        'oper_type': 1,
        'id': row.id,
        'eid': row.eid,
        'typeid': row.type_id,
        'oid': row.oid,
        'oid2': row.oid2, // 入住id
        'fileid': row.fileid,
        'att_name': row.att_name,
        'esp_id': this.$store.state.user.syspersonid,
        'esp_name': this.$store.state.user.personname
      }
      this.addEditTitle = '编辑文件'
      this.addEditFile = true
    },
    delBtn (row) {
      this.sendForm = {
        'oper_type': 2,
        'id': row.id,
        'eid': row.eid,
        'typeid': row.type_id,
        'oid': row.oid,
        'oid2': row.oid2, // 入住id
        'fileid': row.fileid,
        'att_name': row.att_name,
        'esp_id': this.$store.state.user.syspersonid,
        'esp_name': this.$store.state.user.personname
      }
      this.$confirm('此操作将删除该文件【' + row.att_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        queryservicefileupdate(this.sendForm).then(res => {
          this.getFileTable()
          this.$notify({title: '成功', message: '成功删除文件', type: 'success', duration: 2000})
        }).catch(() => {})
      }).catch(() => {})
    },
    submitAddEditFile (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.sendForm.fileid === 0) {
            this.$message({
              message: '请选择文件上传。',
              type: 'warning'
            })
            return
          }
          queryservicefileupdate(this.sendForm).then(res => {
            this.getFileTable()
            if (this.sendForm.oper_type === 0) {
              this.$notify({title: '成功', message: '成功上传文件', type: 'success', duration: 2000})
            } else {
              this.$notify({title: '成功', message: '成功编辑文件', type: 'success', duration: 2000})
            }
            this.addEditFile = false
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/servicePersonFile.vue